export const REPORT_SETTINGS_ROW_LABEL = "Reports";

export const REPORT_SETTINGS_ROW_DESCRIPTION =
    "Layout and number format for reports in Kick and on download";

export const REPORT_SETTINGS_DRAWER_TITLE = "Customize reports";

export const REPORT_SETTINGS_TEMPLATE_DRAWER_TITLE = "Edit template";

export type ReportSettingsEditorSubject =
    | { kind: "workspace"; workspaceId: string; entityId?: number }
    | { kind: "template"; templateId: string; templateName: string };
